<template>
    <div class="date-time-picker" :class="theClasses">
        <b-row>
            <b-col :cols="withTime ? 6 : 12">
                <div class="form-group">
                    <label v-if="!!label" for=""
                        >{{ label }}
                        <span v-if="!!required" class="field-required-mark"
                            >*</span
                        ></label
                    >
                    <input
                        type="text"
                        :placeholder="placeholder"
                        class="form-control date datepicker"
                        :id="inputId"
                        :tabindex="tabindex"
                        @input="setDatetime"
                        :value="formatedDate"
                    />
                </div>
            </b-col>
            <b-col cols="3" v-if="withTime">
                <div class="form-group timepicker">
                    <label for="">Hora</label>
                    <b-form-select
                        :value="formatedHour"
                        :options="hours"
                        @change="setHour"
                        text-field="name"
                        value-field="id"
                    >
                    </b-form-select>
                </div>
            </b-col>
            <b-col cols="3" v-if="withTime">
                <div class="form-group timepicker">
                    <label for="">Minutos</label>
                    <b-form-select
                        :value="formatedMinute"
                        :options="minutes"
                        @change="setMinute"
                        text-field="name"
                        value-field="id"
                    >
                    </b-form-select>
                </div>
            </b-col>
        </b-row>
        <span class="field-error" v-if="hasError">{{ errorMessage }}</span>
    </div>
</template>
<script>
import { between } from 'vuelidate/lib/validators'

export default {
    props: {
        id: {
            type: String,
        },
        tabindex: {
            type: String,
            default: '1',
        },
        required: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: 'Valor incorrecto',
        },
        label: {
            type: String,
            default: '',
        },
        withTime: {
            type: Boolean,
            default: true,
        },
        classes: {},
        value: {
            type: String,
        },
        placeholder: {
            type: String,
            default: 'dd/mm/yyyy',
        },
        maxDate: {
            type: Date,
            default: () =>
                moment()
                    .add(100, 'y')
                    .toDate(),
        },
        minDate: {
            type: Date,
            default: () =>
                moment()
                    .add(-100, 'y')
                    .toDate(),
        },
    },
    data() {
        return {
            date: '',
            hour: '00',
            minute: '00',
            hours: getHours(),
            minutes: getMinutes(),
            patterns: [/^\d{2}\/\d{2}\/\d{4}$/, /^\d{4}-\d{2}-\d{2}$/],
        }
    },
    watch: {
        value(val) {
            this.date = getDate(val).format('DD/MM/YYYY')
        },
    },
    validations: {
        hour: { between: between(0, 23) },
        minute: { between: between(0, 59) },
    },
    computed: {
        inputId() {
            return `input_${Math.floor(Math.random() * 1000000)}`
        },
        theClasses() {
            if (typeof this.classes === 'string') {
                const classes = {}
                classes[this.classes] = 1
                return classes
            }

            if (Array.isArray(this.classes)) {
                const classes = {}
                this.classes.map(theClass => (classes[theClass] = 1))
                return classes
            }

            if (
                this.classes &&
                typeof this.classes === 'object' &&
                this.classes.constructor === Object
            ) {
                return this.classes
            }
        },
        formatedDate() {
            if (!this.patterns.filter(format => format.test(this.value)).length)
                return ''

            const format = 'DD/MM/YYYY'
            let date

            if (moment(this.value, format).isValid()) {
                date = moment(this.value, format)
            } else {
                date = moment(this.value)
            }

            return date.format(format)
        },
        formatedHour() {
            if (!this.withTime) return ''

            return moment(this.value).format('HH')
        },
        formatedMinute() {
            if (!this.withTime) return ''

            return moment(this.value).format('mm')
        },
    },
    methods: {
        setDatetime() {
            if (!this.date || this.$v.$invalid) {
                this.$emit('input', '')
                this.$emit('change', '')
                return false
            }
            let tmpHour = !!this.hour ? this.hour.padStart(2, '0') : '00'
            let tmpMinute = !!this.minute ? this.minute.padStart(2, '0') : '00'
            const tmpSeconds = '00'
            let dateTime
            if (this.withTime) {
                // dateTime = `${moment(this.date).format('DD/MM/YYYY')} ${tmpHour}:${tmpMinute}:${tmpSeconds}`;
                dateTime = `${moment(this.date).format(
                    'YYYY-MM-DD'
                )} ${tmpHour}:${tmpMinute}:${tmpSeconds}`
            } else {
                // dateTime = `${moment(this.date).format('DD/MM/YYYY')}`;
                dateTime = `${moment(this.date).format('YYYY-MM-DD')}`
            }

            this.$emit('input', dateTime)
            this.$emit('change', dateTime)
        },
        clear() {
            this.date = ''
            this.hour = ''
            this.minute = ''
        },
        setHour(hour) {
            this.hour = hour
            this.$v.hour.$touch()
            this.setDatetime()
        },
        setMinute(min) {
            this.minute = min
            this.$v.minute.$touch()
            this.setDatetime()
        },
        fillForm() {
            if (!this.value) return ''
            let format = ''

            const current = getDate(this.value)

            let minute = 0
            const currentMinute = current.format('mm')

            if (currentMinute < 15) minute = '0'
            if (currentMinute >= 15 && currentMinute < 30) minute = '15'
            if (currentMinute >= 30 && currentMinute < 45) minute = '30'
            if (currentMinute >= 45 && currentMinute < 59) minute = '45'

            this.date = current.format('YYYY-MM-DD')
            this.hour = current.format('HH')
            this.minute = minute
        },
    },
    mounted() {
        $(`#${this.inputId}`).datepicker({
            // dateFormat: 'dd/mm/yy',
            dateFormat: 'yy-mm-dd',
            maxDate: this.maxDate,
            minDate: this.minDate,
            onSelect: text => {
                this.date = text
                this.setDatetime()
            },
        })

        let id = !!this.id ? this.id : parseInt(Math.random() * 1000)
        this.$bus.$on(`${id}.clear`, this.clear)
        this.fillForm()
    },
    created() {},
}

const getHours = () => {
    const hours = []
    for (let i = 0; i <= 23; i++) {
        hours.push({
            id: `${('0' + i).substr(-2)}`,
            name: `${('0' + (i > 12 ? i - 12 : i)).substr(-2)} ${
                i < 12 ? 'AM' : 'PM'
            }`,
        })
    }
    return hours
}

const getMinutes = () => {
    const minutes = []
    for (let i = 0; i <= 45; i += 15) {
        minutes.push({
            id: `${('0' + i).substr(-2)}`,
            name: `${('0' + i).substr(-2)}`,
        })
    }
    return minutes
}

const getDate = current => {
    let format = ''
    if (/^\d{2}\/\d{2}\/\d{4}$/g.test(current)) {
        format = 'DD/MM/YYYY'
    } else if (/^\d{4}-\d{2}-\d{2}$/g.test(current)) {
        format = 'YYYY-MM-DD'
    } else if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/g.test(current)) {
        format = 'DD/MM/YYYY HH:mm'
    } else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/g.test(current)) {
        format = 'YYYY-MM-DD HH:mm'
    }

    return moment(current, format)
}
</script>
<style>
.datepicker1 {
    flex: 0 0 50%;
}
.timepicker1 {
    flex: 0 0 20%;
    margin-left: 15px;
}
</style>
